import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useApiClient } from '../contexts/ApiContext';
import { queryKeys } from '../lib/queryClient';

/** Today's active raffle rounds, one per ticket tier, ticket ASC. */
export function useRushRaffleRounds(enabled = true) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: queryKeys.rushRaffleRounds,
    queryFn: () => apiClient.api.rushRaffleControllerGetRounds(),
    enabled,
    refetchOnMount: 'always',
    placeholderData: keepPreviousData,
  });
}

/** One raffle round — prize, leaderboard (top-50), caller stats, winner once completed. */
export function useRushRaffleRoundDetail(roundId: string | null) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: queryKeys.rushRaffleRoundDetail(roundId as string),
    queryFn: () => apiClient.api.rushRaffleControllerGetRoundDetail(roundId as string),
    enabled: !!roundId,
    refetchOnMount: 'always',
    refetchInterval: 60_000,
  });
}

/** The caller's raffle ticket award for a finished Rush Mid match (null if none). */
export function useRushRaffleMatchAward(matchId: string | null) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: queryKeys.rushRaffleMatchAward(matchId as string),
    queryFn: () => apiClient.api.rushRaffleControllerGetMatchAward(matchId as string),
    enabled: !!matchId,
  });
}

/** Recent completed raffle rounds with a winner, last 14 days, newest first. */
export function useRushRaffleWinners(enabled = true) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: queryKeys.rushRaffleWinners,
    queryFn: () => apiClient.api.rushRaffleControllerGetWinners(),
    enabled,
    refetchOnMount: 'always',
  });
}
